import { gql } from 'apollo-boost'

const MARK_BRAND_GATEWAY_TASK_MISC_AS_VERIFIED = gql`
  mutation markBrandGatewayTaskMiscAsVerified($id: ID!, $comment: String) {
    markBrandGatewayTaskMiscAsVerified(id: $id, comment: $comment) {
      id
      miscTaskVerifiedDate
      miscTaskVerifiedComment
    }
  }
`

export default MARK_BRAND_GATEWAY_TASK_MISC_AS_VERIFIED
